module.exports = __webpack_public_path__ + "static/media/7.ba10a766.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/7.jpg
// module id = 1739
// module chunks = 0